import { getQueryParameters, createQueryString } from '@sixfold/app-utils';
import { NavLink, useLocation } from 'react-router';

import { FormattedDate } from '../../components/date_formatting/formatted_date';
import { TIMELINE_TIMESTAMP_QS } from '../../map/components/map_slider';

interface TimestampLinkProps {
  timestamp: string | null;
}

export const TimestampLink = ({ timestamp }: TimestampLinkProps) => {
  const location = useLocation();

  const existingQueryParameters = getQueryParameters(location.search);

  const timestampUrl = `${location.pathname}?${createQueryString({
    ...existingQueryParameters,
    [TIMELINE_TIMESTAMP_QS]: timestamp,
  })}`;
  return (
    <NavLink to={timestampUrl}>
      <FormattedDate date={timestamp} />
    </NavLink>
  );
};
